import { atom } from 'recoil';
import { NavigationProps } from '../../types/navigation';


export const navigationPropsState = atom<NavigationProps>({
  key: 'navigationProps',
  default: { activeNavigationTab: 'home' },
});
